import { TDefaultTheme } from '@lib/theme/defaultTheme';
import classNames from 'classnames';
import React from 'react';
import PageHeader, { PageHeaderProps } from '../page-header';
import Paper from '../paper';
import { PageHeaderWrapperSC } from './page-header-wrapper.styled';

interface PageHeaderWrapperProps extends Omit<PageHeaderProps, 'children'> {
  children: React.ReactNode;
  className?: string;
  headerContent?: React.ReactNode;
  variant?: keyof TDefaultTheme['color']['surface'];
  stickyHeader?: boolean;
}

const PageHeaderWrapper = (props: PageHeaderWrapperProps, ref?: React.Ref<HTMLDivElement>) => {
  const {
    children,
    className,
    title,
    onBack,
    extra,
    footer,
    showBreadcrumbs,
    showDivider = true,
    subTitle,
    headerContent,
    variant = 'baseline',
    stickyHeader = false,
  } = props;

  return (
    <PageHeaderWrapperSC
      className={classNames('ui-page-header-wrapper', className, {
        'sticky-header': stickyHeader,
      })}
      ref={ref}
      variant={variant}
    >
      <PageHeader
        className="page-header"
        title={title}
        onBack={onBack}
        extra={extra}
        footer={footer}
        showBreadcrumbs={showBreadcrumbs}
        showDivider={showDivider}
        subTitle={subTitle}
      >
        {headerContent}
      </PageHeader>
      <Paper variant={variant} className="page-children" type="default">
        {children}
      </Paper>
    </PageHeaderWrapperSC>
  );
};

export default React.forwardRef(PageHeaderWrapper);
